<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { ControlValidator, ValidatorMessages } from "./validators";
  import type { Control } from "./controls";
  import InputControl from "./InputControl.svelte";
  import InputControlErrors from "./InputControlErrors.svelte";

  type TControl = $$Generic<Control<any>>;
  const dispatch = createEventDispatcher<{ change: TControl }>();

  // either set name and validators
  export let name: string = null;
  export let validators: ControlValidator[] = [];
  export let value: any = undefined;
  // ... or bind a control
  export let control: TControl = null;
  export let standalone: boolean = false;
  export let displayName: string = undefined;
  export let errors: ValidatorMessages = undefined;
</script>

<div class="input-formfield">
  <InputControl {name} {displayName} {errors} {validators} {value} {control} {standalone} let:control on:change={(_) => dispatch("change", control)}>
    <slot {control} />
    <InputControlErrors {control} />
  </InputControl>
</div>

<style lang="scss" global>
  .input-formfield {
    label {
      margin-bottom: 0.5rem;
    }
    position: relative;
    display: flex;
    flex-flow: column;
    width: 100%;
  }
</style>
